import Vue from 'vue'
export default {
 	setData(state,data){  //获取用户的教材和学科信息
  		state.quickData = data
	},
	setQuestion(state,obj){  //同步习题所有的选中的题
 		state.qid.push(obj.id)
  	state.question.push(obj)
	},
	delQuestion(state,obj){  //同步习题所有的删除的题
  		var list = state.question
  		list.forEach((m,n)=>{
  			if(m.id == obj.id){
  				list.splice(n,1)
  				state.qid.splice(n,1)
  			}
  		})
  		state.question = list
	},
  setWrong(state,obj){
      state.wrong = obj;
  },
  setKnowledgeid(state,qids){
    state.knowledgeid = qids;
  },
  setKnowledgedata(state,data){
    state.knowledgedata = data;
  },
  setexercisesid(state,qids){
    state.exercisesid = qids;
  },
  setexercisestitle(state,title){
    state.exercisestitle = title;
  },
  setexercisesdetails(state,details){
    state.exercisesdetails = details;
  },
  // 初中同步习题 单元复习储存章节的id
  setchapterid(state,qid){
    state.chapterid = qid;
  },
  // 初中同步习题 单元复习 筛选页的id
  setscreenid(state,qid){
    state.screenid = qid;
  },
  // 初中同步习题 单元复习 发布的组合的id
  setreleaseid(state,qid){
    state.releaseid = qid;
  },
  // 初中同步习题 发布的组合的id
  setsendid(state,qid){
    state.sendid = qid;
  },
  // 全部习题
  setMathTasks(state, data) {
    state.tasks = data;
  },
  // 全部习题
  setWorkSubmit(state, data) {
    state.work_submit = data;
  },
  // 结果页单个题数据
  setSinglereslut(state, data) {
    state.single_reslut = data;
  }
}

